// extracted by mini-css-extract-plugin
export var content = "FormCheckbox-module--content--1fe40";
export var contentWrapper = "FormCheckbox-module--contentWrapper--030e1";
export var fadeInAnimation = "FormCheckbox-module--fadeInAnimation--efa39";
export var hint = "FormCheckbox-module--hint--a4d0a";